import { error as logError } from '../utils/logger'
import { apiUrl } from '../config/config'
import { sendRequest } from '../utils/FetchServices'

interface PropsGetDoti {
    authToken: string
    retries?: number
    timeout?: number
}

export const request_get_doti = async ({ authToken, retries = 2, timeout = 10 }: PropsGetDoti) => {
    const URL = apiUrl + '/oneapp/get_doti'
    try {
        const headers = {
            Authorization: authToken,
        }
        const data = await sendRequest(URL, 'GET', headers, null, retries, timeout)

        return data.response
    } catch (error) {
        logError('TriviaService', 'request_get_doti failed', error)
        return null
    }
}
